<template>
  <div class="person-model-edit-form flex h-full flex-col overflow-hidden">
    <TabsRoot v-model="activeTab" class="flex h-full flex-col overflow-hidden">
      <TabsList class="space-x-1">
        <TabsTrigger value="general" as-child>
          <GeneralButton
            color="primary-lighten-1"
            :variant="activeTab === 'general' ? undefined : 'outlined'"
            class="rounded-b-none"
          >
            Algemeen
          </GeneralButton>
        </TabsTrigger>
        <TabsTrigger value="availability" as-child>
          <GeneralButton
            color="primary-lighten-1"
            :variant="activeTab === 'availability' ? undefined : 'outlined'"
            class="rounded-b-none"
          >
            Beschikbaarheid
          </GeneralButton>
        </TabsTrigger>
      </TabsList>

      <TabsContent
        value="general"
        class="primary-lighten-1 w-full grow overflow-auto rounded-md rounded-tl-none! p-2"
      >
        <PersonModelEditFormGeneral />
      </TabsContent>
      <TabsContent
        value="availability"
        class="primary-lighten-1 w-full grow overflow-auto rounded-md rounded-tl-none! p-2"
      >
        <PersonModelEditFormAvailability />
      </TabsContent>
    </TabsRoot>
  </div>
</template>

<script setup lang="ts">
import { inject, ref } from "vue"
import { TabsContent, TabsList, TabsRoot, TabsTrigger } from "reka-ui"
import GeneralButton from "@/components/inputs/GeneralButton.vue"
import PersonModelEditFormGeneral from "@/components/person/PersonModelEditFormGeneral.vue"
import PersonModelEditFormAvailability from "@/components/person/PersonModelEditFormAvailability.vue"
type PersonModelEditFormTab = "general" | "availability"

const creationParameters = inject<{ initialTab?: PersonModelEditFormTab } | undefined>(
  "creationParameters"
)
const activeTab = ref<PersonModelEditFormTab>(creationParameters?.initialTab ?? "general")
</script>

<style scoped></style>
